module.exports = __webpack_public_path__ + "img/illustration-accueil-sm.89bd4daf.png";